import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Edit, SimpleForm, SelectInput, required, ShowButton, ReferenceField, useRefresh, TextInput } from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import ISConfig from '../config';
import CardActions from "@material-ui/core/CardActions";
import BackButton from '../components/BackButton';
import CustomTextField from '../components/CustomTextField';
import CustomNameLocationInput from '../components/CustomNameLocationInput';
import CustomAddressInput from '../components/CustomAddressInput';
import CustomContactInput from '../components/CustomContactInput';
import ContactIcon from '@material-ui/icons/PermPhoneMsg';
import AddressIcon from '@material-ui/icons/Room';
import ContactAdd from '../contacts/ContactAdd';
import CustomLabelInput from '../components/CustomLabelInput';

const LocationEditActions = ({ basePath, data }) => (
    <CardActions>
        <BackButton style={{ marginRight: "auto" }}></BackButton>
        <ShowButton basePath={basePath} record={data} />
    </CardActions>
);

const LocationEditGeneral = ({ record }) => {
    var LocationStatusSelectChoices = [];
    ISConfig.statuses.location.forEach(element => { LocationStatusSelectChoices.push({ id: element, name: element }) });

    return (
        <div className="row mb-3 mb-md-0">
            <div className="col-12 col-xs-12 col-md-6">
                <div className="row">
                    <div className="col-4 col-xs-2 col-sm-4 col-md-3">
                        <TextInput disabled source="code" className="p-0" label={<CustomLabelInput label="Code" />} fullWidth variant="outlined" />
                    </div>
                    <div className="col-8 col-xs-6 col-sm-6 col-md-5">
                        <CustomNameLocationInput />
                    </div>
                    <div className="col">
                        <SelectInput source="status" validate={required()} choices={LocationStatusSelectChoices} label={<CustomLabelInput label="Status" />} variant="outlined" fullWidth />
                    </div>
                    <div className="col-12 col-md-4 mb-4">
                        <h6 className="text-secondary" style={{ marginBottom: '2px', fontSize: '11px', fontFamily: 'Arial, sans-serif' }}>Customer</h6>
                        <ReferenceField style={{ margin: '0px' }} label="" source="customer_id" resource="customers" reference="customers"><CustomTextField className="m-0 p-0" source="name" fullWidth /></ReferenceField>
                    </div>
                </div>
            </div>
            <div className="col-12 col-xs-12 col-md-6 px-4 pt-1">
                <LocationEditNotes record={record} />
            </div>
        </div>
    );
};

const LocationEditNotes = ({ record }) => {
    return (
        <div className="row">
            <div className="rounded" style={{ border: '1px solid', borderColor: 'rgb(211, 211, 211)' }}>
                <RichTextInput source="notes" label="Notes" stripTags emptyText="Notes" />
            </div>
        </div>
    );
};

const LocationEdit = (props) => {
    return (
        <>
            <h3 className="text-danger px-3 px-md-0 pt-3 pt-md-0" style={{ fontFamily: 'Arial, sans-serif' }}>Edit Location</h3>
            <Edit title=" " actions={<LocationEditActions />} {...props}>
                <SimpleForm redirect="show">
                    <LocationEditGeneral record={{ ...props }} />

                    <h6 className="font-weight-normal pt-2">{<AddressIcon className="d-inline text-danger" style={{ fontSize: '28px' }} />} Address</h6>
                    <div className="w-100 mt-3">
                        <CustomAddressInput record={{ ...props }} />
                    </div>

                    <div className="">
                        <h6 className="font-weight-normal pt-2">{<ContactIcon className="d-inline text-danger" style={{ fontSize: '28px' }} />} Contact <ContactAdd record={{ ...props }} onChange={useRefresh()} /></h6>
                    </div>
                    <div className="w-100">
                        <CustomContactInput record={{ ...props }} />
                    </div>
                </SimpleForm>
            </Edit>
        </>
    )
};


export default LocationEdit;
